import { IComponent, IComponentService, IServices, IInstallServices } from "../_types/interfaces";

const getAddress = async (): Promise<string> => {
    return new Promise<string>(resolve => setTimeout(() => resolve(
        "http://84.201.169.119:18080",
    ), 1000));
};

const getServices = async (uriService: string): Promise<Array<IComponentService>> => {
    return new Promise<Array<IComponentService>>(resolve => setTimeout(() => resolve([
        {name: 'Reader', version: "1.0.0.0"},
        {name: 'Web', version: "1.0.0.0"},
    ]), 1000));
};

const getInstallServices = async (): Promise<Array<IComponentService>> => {
    return new Promise<Array<IComponentService>>(resolve => setTimeout(() => resolve([
        {name: 'Reader', version: "1.0.0.0"},
        {name: 'Updater', version: "1.0.0.0"}
    ]), 1000));
};

const getPlugins = async (uriService: string): Promise<Array<IComponentService>> => {
    return new Promise<Array<IComponentService>>(resolve => setTimeout(() => resolve([
        {name: 'Plugin_R_LocalLoader', version: "1.0.0.0"},
        {name: 'Plugin_M_Packet70', version: "1.0.0.0"}
    ]), 1000));
};


const getInstallPlugins = async (): Promise<Array<IComponentService>> => {
    return new Promise<Array<IComponentService>>(resolve => setTimeout(() => resolve([
        {name: 'Plugin_R_LocalLoader', version: "1.0.0.0"}
    ]), 1000));
};

const addServices = async (services: Array<string>): Promise<void> => {
    return console.log("Сервисы на добавление:" + services);
};

const deleteServices = async (services: Array<string>): Promise<void> => {
    return console.log("Сервисы на удаление:" + services);
};

const getUpdateServices = async (): Promise<IServices> => {
    return new Promise<IServices>(resolve => setTimeout(() => resolve({
        services: [
            {name: 'Reader', version: '2.0.0.0', download: 'today'},
            {name: 'Web', version: '2.0.0.0', download: 'today'},
        ]
    }), 1000));
};

const updateServices = async (services: IInstallServices): Promise<void> => {
    return console.log(services);
};

const requestDownloadService = async (): Promise<void> => {
    return console.log("Request send download");
};

let status = 0;

const checkDownloadLoadStatus = async (): Promise<boolean> => {
    if(status == 0)
    {
        status = 1
        setTimeout(() => {status = 2}, 5000);
        return true;
    }
    if(status == 2)
    {
        status = 0;
        return false;
    }
    return true;
};

let statusUpdate = 0;
const checkUpdateLoadStatus = async (): Promise<boolean> => {
    if(statusUpdate == 0)
    {
        statusUpdate = 1
        setTimeout(() => {statusUpdate = 2}, 5000);
        return true;
    }
    if(statusUpdate == 2)
    {
        statusUpdate = 0;
        return false;
    }
    return true;
};

let statusDelete = 0;
const checkDeleteLoadStatus = async (): Promise<boolean> => {
    if(statusDelete == 0)
    {
        statusDelete = 1
        setTimeout(() => {statusDelete = 2}, 5000);
        return true;
    }
    if(statusDelete == 2)
    {
        statusDelete = 0;
        return false;
    }
    return true;
};




export const fakeComponentService: IComponent = {
    getAddress,
    getServices,
    getPlugins,
    getInstallServices,
    getInstallPlugins,
    addServices,
    deleteServices,
    getUpdateServices,
    requestDownloadService,
    updateServices,
    checkDownloadLoadStatus,
    checkUpdateLoadStatus,
    checkDeleteLoadStatus,
};